import { Component } from '@angular/core';

@Component({
  selector: 'num-information-section',
  templateUrl: './information-section.component.html',
  styleUrls: ['./information-section.component.scss'],
})
export class InformationSectionComponent {}
